import {FormConfig} from '../../../models/form-config';
import {PaymentMethodSectionFieldKey} from '../../../../core/consts/payment-method-section-field-key.enum';
import {FieldType} from '../../../models/field-type';
import {Validator} from '../../../models/validator.enum';
import {RadioOptionConfig} from '../../../models/field-config';
import {PaymentMethodsService} from '../../../../core/services/impl/section-services/method-payments/payment-methods.service';
import {TranslateService} from '@ngx-translate/core';

export class NextPaymentMethodSectionConfig {

    private methodPaymentsService: PaymentMethodsService;
    private ts: TranslateService;

    constructor(methodPaymentsService: PaymentMethodsService,
                ts: TranslateService) {
        this.methodPaymentsService = methodPaymentsService;
        this.ts = ts;
    }

    createConfig(): FormConfig {
        const autoSelectedMethod = this.methodPaymentsService.allowedMethodsConfig.find(methodConfig => methodConfig.autoSelected);
        return {
            formKey: 'PAYMENT_METHOD_SECTION',
            fieldsConfig: [
                {
                    fieldKey: PaymentMethodSectionFieldKey.PAYMENT_METHOD,
                    type: FieldType.RadioCheckboxTile,
                    validators: [Validator.REQUIRED],
                    radioConfig: this.createRadioOptionsConfig(),
                    radioCheckboxTileConfig: {
                        contentDataValuePropertyName: 'method',
                        getAnalyticsFieldValue: itemData => this.ts.instant(itemData.label)
                    },
                    analyticsConfig: {
                        customFieldName: 'METHOD_PAYMENT_SECTION.title'
                    },
                    initialValue: autoSelectedMethod ? autoSelectedMethod.method : undefined
                }
            ]
        }
    }

    private createRadioOptionsConfig(): RadioOptionConfig[] {
        return this.methodPaymentsService.allowedMethodsConfig.map(config => ({
            value: config.method,
            label: config.label
        }));
    }
}
